import { useEffect, useMemo } from 'react';
import { useNexusRelationshipStore } from '../../../stores/prioritization/nexusRelationshipStore';
import { getCurrentWorkspaceId } from '../../../lib/supabaseSync';
import type { NexusRelationshipProposal } from '../../../lib/nexusAgentService';

const EMPTY: NexusRelationshipProposal[] = [];

/** Every relationship this agent proposed that still waits for a person, newest first. */
export function useOpenRelationshipProposals(agentType: string): NexusRelationshipProposal[] {
  const workspaceId = getCurrentWorkspaceId();
  const proposals = useNexusRelationshipStore((s) => (workspaceId ? s.byWorkspace[workspaceId]?.proposals : undefined) ?? EMPTY);
  const fetchProposals = useNexusRelationshipStore((s) => s.fetchProposals);
  useEffect(() => {
    if (workspaceId) void fetchProposals(workspaceId);
  }, [workspaceId, fetchProposals]);
  return useMemo(
    () => proposals.filter((p) => p.proposedByAgent === agentType && p.status === 'active')
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()),
    [proposals, agentType],
  );
}
